import { Box, Icon, Typography } from "@mui/material"
import { icons } from "../../../utils/icons"
import { useStyles } from "./styles"

function NoComments({ label }: { label: string }) {
  const styles = useStyles()
  return (
    <Box sx={styles.noResponse}>
      <Icon>{icons('QuestionAnswer')}</Icon>

      <Typography variant="subtitle" fontWeight='500'>{label}</Typography>
    </Box>
  )
}

export { NoComments }